import action from '../../../abstract/action.js';

export default action({
  label: 'Edytuj',
  icon: 'EditIcon',
  main: false,
  handle: async ({ $router, item: { id } }) => await $router.push({ name: 'admin-mailing-templates-edit', params: { id } }),
});